import * as React from 'react';
import Stack from '@mui/material/Stack';
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { styled } from "@mui/material/styles";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Terms from "../Policy/Terms";
import Private from "../Policy/Private";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import UsePolicy from '../Policy/UsePolicy';
import Collect from '../Policy/Collect';
import Third from '../Policy/Third';
import Ads from '../Policy/Ads';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const JoinAgreePop = (props: any) => {
  type Anchor = 'bottom'
  const [state, setState] = React.useState({
    bottom: false,
  });

  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      {(['bottom'] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <KeyboardArrowRightIcon sx={{ ml: 'auto', color: '#999' }} onClick={handleClickOpen} />
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            sx={{ '& > div > .MuiDialog-paper': { width: '50%' } }}
          >
            <DialogTitle sx={{ m: 0, p: 2, fontWeight: 'bold' }} id="customized-dialog-title">
              전체 약관 동의
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'theme.palette.grey[500]',
              })}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers sx={{ '& .MuiPaper-root': { display: 'none' }, '& .container': { p: 0, ml: '0px !important', width: '100%', maxWidth: '100%!important' } }}>
              <Typography gutterBottom>{props.type === 'terms' ? <Terms /> : props.type === 'private' ? <Private /> : props.type === 'collect' ? <Collect /> : props.type === 'third' ? <Third /> : props.type === 'ads' ? <Ads /> : <UsePolicy />}</Typography>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleClose} sx={{ bgcolor: '#0d6703', color: '#fff', width: 100, borderRadius: 20, '&:hover': { bgcolor: '#074300' } }}>
                확인
              </Button>
            </DialogActions>
          </BootstrapDialog>
        </React.Fragment>
      ))}
    </React.Fragment >
    // <React.Fragment>
    //   {(['bottom'] as const).map((anchor) => (
    //     <React.Fragment key={anchor}>
    //       <KeyboardArrowRightIcon sx={{ ml: 'auto', color: '#999' }} onClick={toggleDrawer(anchor, true)}/>
    //       <SwipeableDrawer
    //         anchor={anchor}
    //         open={state[anchor]}
    //         onClose={toggleDrawer(anchor, false)}
    //         onOpen={toggleDrawer(anchor, true)}
    //       >
    //         <Stack sx={{
    //           '& header' : {display:'none'},
    //           '& .contentStart' : {mt:0},
    //           '& .MuiBottomNavigation-root' : {display:'none'}
    //         }}> 
    //           <HighlightOffIcon sx={{ ml: 'auto', color: '#c10b0b', p:2, fontSize:30}} onClick={toggleDrawer(anchor, false)}/>
    //           {/* <Divider /> */}
    //           {props.type === 'terms' ? <Terms /> : <Private />}
    //           <Terms />
    //           </Stack>

    //       </SwipeableDrawer>
    //     </React.Fragment>
    //   ))}
    // </React.Fragment >
  );
}

export default JoinAgreePop;